import Vue from 'vue';

export const PHONE_DISPLAY = 'phone';
export const PHONE_LINK = 'phone_link';

Vue.filter(PHONE_DISPLAY, (value: string) => {
  if (!value) {
    return '';
  }

  return value.replace(
    /(?:\()?(\d{3})(?:\))?(?:\s)?(?:-)?(\d{3})?(?:-)?(\d{4})/,
    '($1) $2-$3'
  );
});

Vue.filter(PHONE_LINK, (value: string) => {
  if (!value) {
    return '';
  }

  return value.replace(/([+]+\d{1})|[()-.\s]/g, '');
});
